// tslint:disable
/**
 * TriplogGUIBff
 * Triplog GUI Bff
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Average
 */
export interface Average {
    /**
     * Average name
     * @type {string}
     * @memberof Average
     */
    name: string;
    /**
     * 
     * @type {StatValue}
     * @memberof Average
     */
    value: StatValue;
}
/**
 * 
 * @export
 * @interface CarHealth
 */
export interface CarHealth {
    /**
     * 
     * @type {string}
     * @memberof CarHealth
     */
    aggregateState?: CarHealthAggregateStateEnum;
    /**
     * 
     * @type {Array<MaintenanceItem>}
     * @memberof CarHealth
     */
    maintenanceItems?: Array<MaintenanceItem>;
    /**
     * Number of issues influencing the aggregateState
     * @type {number}
     * @memberof CarHealth
     */
    numIssues?: number;
    /**
     * Percentage of fuel level
     * @type {number}
     * @memberof CarHealth
     */
    lastFuelLevel?: number;
    /**
     * Odometer in meters
     * @type {number}
     * @memberof CarHealth
     */
    odometer?: number;
    /**
     * 
     * @type {CarHealthHealthIssues}
     * @memberof CarHealth
     */
    healthIssues?: CarHealthHealthIssues;
}

/**
    * @export
    * @enum {string}
    */
export enum CarHealthAggregateStateEnum {
    UNPLUGGED = 'UNPLUGGED',
    RED = 'RED',
    YELLOW = 'YELLOW',
    GREEN = 'GREEN'
}

/**
 * 
 * @export
 * @interface CarHealthHealthIssues
 */
export interface CarHealthHealthIssues {
    /**
     * 
     * @type {boolean}
     * @memberof CarHealthHealthIssues
     */
    showContactButton?: boolean;
    /**
     * 
     * @type {Array<HealthIssueItem>}
     * @memberof CarHealthHealthIssues
     */
    warnings?: Array<HealthIssueItem>;
    /**
     * 
     * @type {Array<HealthIssueItem>}
     * @memberof CarHealthHealthIssues
     */
    recommendations?: Array<HealthIssueItem>;
}
/**
 * Represents a DTC reported by a Device for a given Vehicle
 * @export
 * @interface DTC
 */
export interface DTC {
    /**
     * The DTC id
     * @type {string}
     * @memberof DTC
     */
    id?: string;
    /**
     * DTC code recorded by the device
     * @type {string}
     * @memberof DTC
     */
    code?: string;
    /**
     * Description of the DTC. Description is available for generic codes. Default description is the standard On-board diagnostics(OBD) description.
     * @type {string}
     * @memberof DTC
     */
    description?: string;
    /**
     * DTC class code recorded by the device
     * @type {string}
     * @memberof DTC
     */
    classCode?: string;
    /**
     * Description of DTC class code
     * @type {string}
     * @memberof DTC
     */
    classDescription?: string;
    /**
     * The id of the device that captured the DTC
     * @type {string}
     * @memberof DTC
     */
    deviceId?: string;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    deviceTimestamp?: string;
    /**
     * Extended description of the DTC
     * @type {string}
     * @memberof DTC
     */
    extendedDescription?: string;
    /**
     * Number of times the fault has been reported
     * @type {number}
     * @memberof DTC
     */
    faultNumber?: number;
    /**
     * Indicates a pending or confirmed DTC
     * @type {string}
     * @memberof DTC
     */
    faultType?: string;
    /**
     * Reading of the vehicle odometer when the DTC is triggered
     * @type {number}
     * @memberof DTC
     */
    firstReportedOdometer?: number;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    firstReportedTimestamp?: string;
    /**
     * Identifies if the DTC is current or not, that is, if the DTCs are the most recently scanned DTCs
     * @type {boolean}
     * @memberof DTC
     */
    current?: boolean;
    /**
     * Indicates if a mismatch event occurred during the trip that this DTC was recorded. True indicates a mismatch.
     * @type {boolean}
     * @memberof DTC
     */
    mismatched?: boolean;
    /**
     * Recommended action code for this DTC
     * @type {string}
     * @memberof DTC
     */
    recommendationCode?: string;
    /**
     * Recommended action description for this DTC.
     * @type {string}
     * @memberof DTC
     */
    recommendationDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof DTC
     */
    reportedTimestamp?: string;
    /**
     * The id of the associated trip for this DTC
     * @type {string}
     * @memberof DTC
     */
    tripId?: string;
}
/**
 * 
 * @export
 * @interface Diagram
 */
export interface Diagram {
    /**
     * Diagram name
     * @type {string}
     * @memberof Diagram
     */
    name: string;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    tripCount: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    distance: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    duration: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    speed: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    ecoScore?: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    fuelConsumption: Array<DiagramEntry>;
    /**
     * 
     * @type {Array<DiagramEntry>}
     * @memberof Diagram
     */
    cost: Array<DiagramEntry>;
}
/**
 * 
 * @export
 * @interface DiagramEntry
 */
export interface DiagramEntry {
    /**
     * Formatted diagram name
     * @type {string}
     * @memberof DiagramEntry
     */
    name: string;
    /**
     * Value representing bar length. It may surprass 1.0 when maximum reference value is not the absolute maximum value
     * @type {number}
     * @memberof DiagramEntry
     */
    barPercentage: number;
    /**
     * 
     * @type {StatValue}
     * @memberof DiagramEntry
     */
    value: StatValue;
    /**
     * 
     * @type {DiagramEntryIcon}
     * @memberof DiagramEntry
     */
    icon?: DiagramEntryIcon;
}
/**
 * optional icon. Inclues either a single character or an image name. Includes either a background color or a fill id
 * @export
 * @interface DiagramEntryIcon
 */
export interface DiagramEntryIcon {
    /**
     * Background RGB color
     * @type {string}
     * @memberof DiagramEntryIcon
     */
    color?: string;
    /**
     * id of fill to use. Typically this refers to a gradient defined in the front end
     * @type {string}
     * @memberof DiagramEntryIcon
     */
    fillId?: string;
    /**
     * single or two character string
     * @type {string}
     * @memberof DiagramEntryIcon
     */
    character?: string;
    /**
     * character RGB color
     * @type {string}
     * @memberof DiagramEntryIcon
     */
    characterColor?: string;
    /**
     * svg image name
     * @type {string}
     * @memberof DiagramEntryIcon
     */
    imageName?: string;
}
/**
 * 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {Array<object>}
     * @memberof ErrorResponse
     */
    errors?: Array<object>;
}
/**
 * 
 * @export
 * @interface HealthIssueItem
 */
export interface HealthIssueItem {
    /**
     * Title of this issue
     * @type {string}
     * @memberof HealthIssueItem
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof HealthIssueItem
     */
    description?: string;
    /**
     * 
     * @type {DTC}
     * @memberof HealthIssueItem
     */
    dtc?: DTC;
    /**
     * Type of the data within this item
     * @type {string}
     * @memberof HealthIssueItem
     */
    type?: string;
}
/**
 * 
 * @export
 * @interface Highlight
 */
export interface Highlight {
    /**
     * Highlight name
     * @type {string}
     * @memberof Highlight
     */
    name: string;
    /**
     * 
     * @type {StatValue}
     * @memberof Highlight
     */
    value: StatValue;
    /**
     * The id of the trip the highlight is associated with
     * @type {number}
     * @memberof Highlight
     */
    tripId?: number;
}
/**
 * Represents information for the key data tab: summary, highlights and averages
 * @export
 * @interface KeyData
 */
export interface KeyData {
    /**
     * 
     * @type {KeyDataSummary}
     * @memberof KeyData
     */
    summary: KeyDataSummary;
    /**
     * 
     * @type {Array<Highlight>}
     * @memberof KeyData
     */
    highlights: Array<Highlight>;
    /**
     * 
     * @type {KeyDataAverages}
     * @memberof KeyData
     */
    averages: KeyDataAverages;
}
/**
 * 
 * @export
 * @interface KeyDataAverages
 */
export interface KeyDataAverages {
    /**
     * 
     * @type {Array<Average>}
     * @memberof KeyDataAverages
     */
    perTrip: Array<Average>;
    /**
     * 
     * @type {Array<Average>}
     * @memberof KeyDataAverages
     */
    daily: Array<Average>;
    /**
     * 
     * @type {Array<Average>}
     * @memberof KeyDataAverages
     */
    weekly: Array<Average>;
    /**
     * 
     * @type {Array<Average>}
     * @memberof KeyDataAverages
     */
    monthly: Array<Average>;
}
/**
 * 
 * @export
 * @interface KeyDataSummary
 */
export interface KeyDataSummary {
    /**
     * 
     * @type {number}
     * @memberof KeyDataSummary
     */
    tripCount: number;
    /**
     * distance in kilometres
     * @type {number}
     * @memberof KeyDataSummary
     */
    distance: number;
    /**
     * duration in minutes
     * @type {number}
     * @memberof KeyDataSummary
     */
    duration: number;
}
/**
 * Contains information about a maintenance recommendation
 * @export
 * @interface MaintenanceItem
 */
export interface MaintenanceItem {
    /**
     * id of the maintainance item
     * @type {string}
     * @memberof MaintenanceItem
     */
    id?: string;
    /**
     * Very short text naming this item
     * @type {string}
     * @memberof MaintenanceItem
     */
    name?: string;
    /**
     * A very short text indicating how much time or kilometers the user has remaining before this items becomes overdue.
     * @type {string}
     * @memberof MaintenanceItem
     */
    remainingTimeText?: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceItem
     */
    urgencyIndicator?: MaintenanceItemUrgencyIndicatorEnum;
    /**
     * 
     * @type {MaintenanceItemTrigger}
     * @memberof MaintenanceItem
     */
    dateTrigger?: MaintenanceItemTrigger;
    /**
     * 
     * @type {MaintenanceItemTrigger}
     * @memberof MaintenanceItem
     */
    odometerTrigger?: MaintenanceItemTrigger;
    /**
     * 
     * @type {MaintenanceItemType}
     * @memberof MaintenanceItem
     */
    itemType?: MaintenanceItemType;
}

/**
    * @export
    * @enum {string}
    */
export enum MaintenanceItemUrgencyIndicatorEnum {
    NotUrgent = 'notUrgent',
    Due = 'due',
    Overdue = 'overdue'
}

/**
 * 
 * @export
 * @interface MaintenanceItemTrigger
 */
export interface MaintenanceItemTrigger {
    /**
     * in km or days (negative means shortly before due date, positive is after)
     * @type {number}
     * @memberof MaintenanceItemTrigger
     */
    due: number;
    /**
     * in km or days (negative means shortly before due date, positive is after)
     * @type {number}
     * @memberof MaintenanceItemTrigger
     */
    overdue: number;
    /**
     * period in km or days with custom text, like \'Alle 100 km\' or \'Jährlich\'
     * @type {string}
     * @memberof MaintenanceItemTrigger
     */
    period?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MaintenanceItemType {
    AntiFreeze = 'Anti_freeze',
    Oil = 'Oil',
    P57a = 'P57a',
    WinterTire = 'Winter_tire',
    Vignette = 'Vignette'
}

/**
 * 
 * @export
 * @interface Membership
 */
export interface Membership {
    /**
     * 
     * @type {boolean}
     * @memberof Membership
     */
    valid?: boolean;
}
/**
 * 
 * @export
 * @interface StatValue
 */
export interface StatValue {
    /**
     * Formatted value
     * @type {string}
     * @memberof StatValue
     */
    value: string;
    /**
     * Unit string
     * @type {string}
     * @memberof StatValue
     */
    unit?: string;
}
/**
 * Statistics graphics: route geometries and eco scores
 * @export
 * @interface StatisticGraphics
 */
export interface StatisticGraphics {
    /**
     * 
     * @type {Array<string>}
     * @memberof StatisticGraphics
     */
    routeGeometries: Array<string>;
    /**
     * 
     * @type {StatisticGraphicsEcoScore}
     * @memberof StatisticGraphics
     */
    ecoScore?: StatisticGraphicsEcoScore;
}
/**
 * 
 * @export
 * @interface StatisticGraphicsEcoScore
 */
export interface StatisticGraphicsEcoScore {
    /**
     * 
     * @type {number}
     * @memberof StatisticGraphicsEcoScore
     */
    idlingScore: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticGraphicsEcoScore
     */
    speedingScore: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticGraphicsEcoScore
     */
    brakingScore: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticGraphicsEcoScore
     */
    accelerationScore: number;
    /**
     * 
     * @type {number}
     * @memberof StatisticGraphicsEcoScore
     */
    totalEcoScore: number;
}
/**
 * Statistic for each tab
 * @export
 * @interface StatisticTabs
 */
export interface StatisticTabs {
    /**
     * 
     * @type {KeyData}
     * @memberof StatisticTabs
     */
    keyData: KeyData;
    /**
     * 
     * @type {Array<Diagram>}
     * @memberof StatisticTabs
     */
    diagrams: Array<Diagram>;
    /**
     * 
     * @type {Timelines}
     * @memberof StatisticTabs
     */
    timelines: Timelines;
}
/**
 * Statistic graphics and tabs
 * @export
 * @interface Statistics
 */
export interface Statistics {
    /**
     * 
     * @type {StatisticGraphics}
     * @memberof Statistics
     */
    statisticGraphics: StatisticGraphics;
    /**
     * 
     * @type {StatisticTabs}
     * @memberof Statistics
     */
    statisticTabs: StatisticTabs;
}
/**
 * 
 * @export
 * @interface Timeline
 */
export interface Timeline {
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    tripCount: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    distance: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    duration: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    speed: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    ecoScore?: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    fuelConsumption: Array<TimelineEntry>;
    /**
     * 
     * @type {Array<TimelineEntry>}
     * @memberof Timeline
     */
    cost: Array<TimelineEntry>;
}
/**
 * 
 * @export
 * @interface TimelineEntry
 */
export interface TimelineEntry {
    /**
     * Formatted diagram name
     * @type {string}
     * @memberof TimelineEntry
     */
    name: string;
    /**
     * Value from 0.0 to 1.0 representing bar length
     * @type {number}
     * @memberof TimelineEntry
     */
    barPercentage: number;
    /**
     * 
     * @type {StatValue}
     * @memberof TimelineEntry
     */
    value: StatValue;
}
/**
 * 
 * @export
 * @interface Timelines
 */
export interface Timelines {
    /**
     * 
     * @type {Timeline}
     * @memberof Timelines
     */
    daily: Timeline;
    /**
     * 
     * @type {Timeline}
     * @memberof Timelines
     */
    weekly: Timeline;
    /**
     * 
     * @type {Timeline}
     * @memberof Timelines
     */
    monthly: Timeline;
    /**
     * 
     * @type {Timeline}
     * @memberof Timelines
     */
    fuelCyclic?: Timeline;
}

/**
 * CarHealthApi - axios parameter creator
 * @export
 */
export const CarHealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch car health information
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarHealth: async (filterVehicleId?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/bff/health`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarHealthApi - functional programming interface
 * @export
 */
export const CarHealthApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary fetch car health information
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCarHealth(filterVehicleId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarHealth>> {
            const localVarAxiosArgs = await CarHealthApiAxiosParamCreator(configuration).getCarHealth(filterVehicleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CarHealthApi - factory interface
 * @export
 */
export const CarHealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary fetch car health information
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCarHealth(filterVehicleId?: number, options?: any): AxiosPromise<CarHealth> {
            return CarHealthApiFp(configuration).getCarHealth(filterVehicleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CarHealthApi - object-oriented interface
 * @export
 * @class CarHealthApi
 * @extends {BaseAPI}
 */
export class CarHealthApi extends BaseAPI {
    /**
     * 
     * @summary fetch car health information
     * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarHealthApi
     */
    public getCarHealth(filterVehicleId?: number, options?: any) {
        return CarHealthApiFp(this.configuration).getCarHealth(filterVehicleId, options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * MembershipApi - axios parameter creator
 * @export
 */
export const MembershipApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary check if Membership is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipInfo: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/bff/membership`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembershipApi - functional programming interface
 * @export
 */
export const MembershipApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary check if Membership is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMembershipInfo(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MembershipApiAxiosParamCreator(configuration).getMembershipInfo(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MembershipApi - factory interface
 * @export
 */
export const MembershipApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary check if Membership is valid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMembershipInfo(options?: any): AxiosPromise<void> {
            return MembershipApiFp(configuration).getMembershipInfo(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembershipApi - object-oriented interface
 * @export
 * @class MembershipApi
 * @extends {BaseAPI}
 */
export class MembershipApi extends BaseAPI {
    /**
     * 
     * @summary check if Membership is valid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembershipApi
     */
    public getMembershipInfo(options?: any) {
        return MembershipApiFp(this.configuration).getMembershipInfo(options).then((request) => request(this.axios, this.basePath));
    }

}


/**
 * StatisticApi - axios parameter creator
 * @export
 */
export const StatisticApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary search a vehicle statistics within the given timeframe
         * @param {string} filterFrom do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} filterUntil do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {boolean} [filterSmartConnectInfo] if true, includes smart connect information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics: async (filterFrom: string, filterUntil: string, filterVehicleId?: number, filterSmartConnectInfo?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterFrom' is not null or undefined
            if (filterFrom === null || filterFrom === undefined) {
                throw new RequiredError('filterFrom','Required parameter filterFrom was null or undefined when calling getStatistics.');
            }
            // verify required parameter 'filterUntil' is not null or undefined
            if (filterUntil === null || filterUntil === undefined) {
                throw new RequiredError('filterUntil','Required parameter filterUntil was null or undefined when calling getStatistics.');
            }
            const localVarPath = `/bff/statistics`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filterVehicleId !== undefined) {
                localVarQueryParameter['filter.vehicleId'] = filterVehicleId;
            }

            if (filterFrom !== undefined) {
                localVarQueryParameter['filter.from'] = (filterFrom as any instanceof Date) ?
                    (filterFrom as any).toISOString() :
                    filterFrom;
            }

            if (filterUntil !== undefined) {
                localVarQueryParameter['filter.until'] = (filterUntil as any instanceof Date) ?
                    (filterUntil as any).toISOString() :
                    filterUntil;
            }

            if (filterSmartConnectInfo !== undefined) {
                localVarQueryParameter['filter.smartConnectInfo'] = filterSmartConnectInfo;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticApi - functional programming interface
 * @export
 */
export const StatisticApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary search a vehicle statistics within the given timeframe
         * @param {string} filterFrom do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} filterUntil do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {boolean} [filterSmartConnectInfo] if true, includes smart connect information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStatistics(filterFrom: string, filterUntil: string, filterVehicleId?: number, filterSmartConnectInfo?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Statistics>> {
            const localVarAxiosArgs = await StatisticApiAxiosParamCreator(configuration).getStatistics(filterFrom, filterUntil, filterVehicleId, filterSmartConnectInfo, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * StatisticApi - factory interface
 * @export
 */
export const StatisticApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary search a vehicle statistics within the given timeframe
         * @param {string} filterFrom do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
         * @param {string} filterUntil do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
         * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
         * @param {boolean} [filterSmartConnectInfo] if true, includes smart connect information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStatistics(filterFrom: string, filterUntil: string, filterVehicleId?: number, filterSmartConnectInfo?: boolean, options?: any): AxiosPromise<Statistics> {
            return StatisticApiFp(configuration).getStatistics(filterFrom, filterUntil, filterVehicleId, filterSmartConnectInfo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatisticApi - object-oriented interface
 * @export
 * @class StatisticApi
 * @extends {BaseAPI}
 */
export class StatisticApi extends BaseAPI {
    /**
     * 
     * @summary search a vehicle statistics within the given timeframe
     * @param {string} filterFrom do not return trips before the specified date-time. Format: rfc3339. Default: &#x60;&#x60;1970-01-01T00:00:00Z&#x60;&#x60;
     * @param {string} filterUntil do not return trips after the specified date-time. Format: rfc3339. Default: &#x60;&#x60;now&#x60;&#x60;
     * @param {number} [filterVehicleId] return trips belonging to given vehicle. Statistics from all vehicles are fetch if not set
     * @param {boolean} [filterSmartConnectInfo] if true, includes smart connect information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatisticApi
     */
    public getStatistics(filterFrom: string, filterUntil: string, filterVehicleId?: number, filterSmartConnectInfo?: boolean, options?: any) {
        return StatisticApiFp(this.configuration).getStatistics(filterFrom, filterUntil, filterVehicleId, filterSmartConnectInfo, options).then((request) => request(this.axios, this.basePath));
    }

}


